import { useEffect, useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaPaperPlane,
  FaInstagram,
  FaApple,
  FaAndroid,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CountryFlag from "react-country-flag";
import axios from "axios";
import axiosInstance from "../../axios";
import { useSelector } from "react-redux";
import smiklogo from "../../assets/icons/logo.png";

const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

function Footer() {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("IN");

  const { categories, isLoading, error } = useSelector(state => state?.category);
  const { courses, isFetching } = useSelector(state => state?.course || []);
  const allcourse = courses?.all?.courses || [];
  const courseList = allcourse.filter((item, index) => index <= 15);
  
  const [trendingCourses, setTrendingCourses] = useState([]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      setIsExpanded(!isExpanded);
    }
  };

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
  };

  return (
    <footer className="bg-[#0B0F19] !text-white w-full border-t border-slate-800/60 font-sans m-0 pt-0">
      {/* Mobile Collapsed View */}
      <div className="md:hidden border-b border-slate-800/60 bg-slate-900/30">
        <div
          className="flex items-center justify-between px-6 py-4 cursor-pointer select-none"
          onClick={() => setIsExpanded(!isExpanded)}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex="0"
        >
          <div className="flex items-center gap-2.5">
            <img src={smiklogo} alt="Smik Learn Logo" className="h-6 w-auto" />
            <span className="text-sm font-semibold tracking-tight !text-white">
              <span className="text-blue-500">Yuvasakthi</span>
              <span>Academy</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs !text-white">{isExpanded ? t("Show Less") : t("Explore Links")}</span>
            {isExpanded ? (
              <FaChevronUp className="!text-white transition-transform duration-300" />
            ) : (
              <FaChevronDown className="!text-white transition-transform duration-300" />
            )}
          </div>
        </div>
      </div>

      {/* Main Footer Content - Hidden on mobile unless expanded */}
      {/* <div className={`${isExpanded ? "block animate-fadeIn" : "hidden"} md:block`}> */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 border border-none bg-none">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-10">
            {/* Left Brand Column */}
            <div className="lg:col-span-2 space-y-6">
              <div className="flex items-center gap-2.5">
                <img src={smiklogo} alt="Yuvasakthi Academy Logo" className="h-9 w-auto" />
                <span className="text-xl font-bold tracking-tight !text-white">
                  <span className="text-blue-500">Yuvasakthi</span>
                  <span> Academy</span>
                </span>
              </div>
              <p className="text-[15px] !text-white leading-relaxed max-w-sm">
                {t("Empowering learners worldwide with cutting-edge skills, professional certifications, and career-ready training programs.")}
              </p>
              
              <div className="space-y-3">
                <h4 className="text-xs font-semibold !text-white uppercase tracking-wider">{t("Connect With Us")}</h4>
                <div className="flex flex-wrap gap-2.5">
                  <Link
                    to="https://www.facebook.com/profile.php?id=61561616910198"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to Facebook" title="Facebook" rel="noreferrer"
                  >
                    <FaFacebook size={18} />
                  </Link>
                  <Link
                    to="https://x.com/yslearn"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to Twitter" title="Twitter" rel="noreferrer"
                  >
                    <FaTwitter size={18} />
                  </Link>
                  <Link
                    to="https://www.youtube.com/@yslearn"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to YouTube" title="YouTube" rel="noreferrer"
                  > 
                    <FaYoutube size={18} />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/in/yuvasakthi-academy-2810b8317/"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to LinkedIn" title="LinkedIn" rel="noreferrer"
                  >
                    <FaLinkedin size={18} />
                  </Link>
                  <Link
                    to="#"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to Telegram" title="Telegram" rel="noreferrer"
                  >
                    <FaPaperPlane size={18} />
                  </Link>
                  <Link
                    to="https://www.instagram.com/yuvasakthi_academy/"
                    className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-900 border border-slate-800 !text-white hover:!text-white hover:bg-blue-600 hover:border-blue-500 hover:scale-105 transition-all duration-300"
                    target="_blank" aria-label="link to Instagram" title="Instagram" rel="noreferrer"
                  >
                    <FaInstagram size={18} />
                  </Link>
                </div>
              </div>

              <div className="space-y-3">
                <h4 className="text-xs font-semibold !text-white uppercase tracking-wider">{t("Learn On the Go!")}</h4>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to="#"
                    className="flex items-center gap-3 bg-slate-900 border border-slate-800 rounded-lg px-4 py-2 hover:bg-slate-800 hover:border-slate-700 hover:!text-white transition-all duration-300 w-full sm:w-auto"
                  >
                    <FaAndroid size={24} className="!text-white hover:text-[#3DDC84] transition-colors" />
                    <div className="text-left">
                      <span className="text-[10px] !text-white/80 uppercase tracking-wider block font-medium leading-none">{t("Get it on")}</span>
                      <span className="text-xs font-semibold !text-white block mt-1">{t("Google Play")}</span>
                    </div>
                  </Link>
                  <Link
                    to="#"
                    className="flex items-center gap-3 bg-slate-900 border border-slate-800 rounded-lg px-4 py-2 hover:bg-slate-800 hover:border-slate-700 hover:!text-white transition-all duration-300 w-full sm:w-auto"
                  >
                    <FaApple size={24} className="!text-white hover:!text-blue-500 transition-colors" />
                    <div className="text-left">
                      <span className="text-[10px] !text-white/80 uppercase tracking-wider block font-medium leading-none">{t("Download on the")}</span>
                      <span className="text-xs font-semibold !text-white block mt-1">{t("App Store")}</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Company Section */}
            <div className="space-y-4">
              <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                {t("Company")}
              </h3>
              <div className="flex flex-col space-y-2.5 !text-white">
                <Link
                  to="/about"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("About us")}
                </Link>
                <Link
                  to="/careers"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Careers")}
                </Link>
                <Link 
                  to="/press" 
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Newsroom")}
                </Link>
                <Link
                  to="/grievance-redressal"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Grievance redressal")}
                </Link>
                <Link
                  to="/contact"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Contact us")}
                </Link>
              </div>
            </div>

            {/* Work with us Section */}
            <div className="space-y-4">
              <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                {t("Work with us")}
              </h3>
              <div className="flex flex-col space-y-2.5">
                <Link
                  to="/becomeaninstructor"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Become an instructor")}
                </Link>
                {/* <Link
                  to="https://blog.smiklearn.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Blog as guest")}
                </Link> */}
                <Link
                  to="/smikrecruit"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Hire from us")}
                </Link>
              </div>
            </div>

            {/* Discover Section */}
            <div className="space-y-4">
              <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                {t("Discover")}
              </h3>
              <div className="flex flex-col space-y-2.5">
                <Link
                  to="/skillup"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Skillup Sitemap")}
                </Link>
                <Link 
                  to="/resourse" 
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Resources")}
                </Link>
                <Link 
                  to="/feed" 
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("RSS feed")}
                </Link>
              </div>
            </div>

            {/* For Businesses Section */}
            <div className="space-y-4">
              <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                {t("For Businesses")}
              </h3>
              <div className="flex flex-col space-y-2.5">
                <Link
                  to="/forbusiness"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Corporate training")}
                </Link>
                <Link
                  to="/learning-hub-plus"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("yslearn Learning Hub+")}
                </Link>
                <Link 
                  to="/guaranteed" 
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Guaranteed-to-run Classes")}
                </Link>
                <Link
                  to="/partners"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Partners")}
                </Link>
                <Link
                  to="/demo"
                  className="text-[15px] !text-white hover:!text-blue-500 hover:translate-x-1 transition-all duration-300 ease-in-out py-0.5"
                >
                  {t("Request demo")}
                </Link>
              </div>
            </div>
          </div>

          {/* Trending Sections */}
          <div className="mt-16 pt-12 border-t border-slate-800/80 space-y-10">
            {/* Trending Courses */}
            {courseList?.length > 0 && (
              <div>
                <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                  {t("Trending Courses")}
                </h3>
                <div className="flex flex-wrap gap-y-2 text-[15px] !text-white leading-relaxed">
                  {courseList.map((course, idx) => (
                    <div key={course.ID} className="flex items-center">
                      <Link
                        to={`/${slugify(course.CourseName)}`}
                        className="!text-white hover:!text-blue-500 transition-colors duration-200"
                        state={{ course }}
                      >
                        {course.CourseName}
                      </Link>
                      {idx < courseList.length - 1 && (
                        <span className="mx-3 !text-white/40 select-none">•</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Trending Categories */}
            {categories?.length > 0 && (
              <div>
                <h3 className="text-xs font-semibold !text-white uppercase tracking-wider mb-4 block">
                  {t("Trending Categories")}
                </h3>
                <div className="flex flex-wrap gap-y-2 text-[15px] leading-relaxed">
                  {categories.map((category, idx) => (
                    <div key={category.id} className="flex items-center">
                      <Link
                        to={`/categories/${slugify(category.categoryName)}/${category.id}`}
                        className="!text-white hover:!text-blue-500 transition-colors duration-200"
                        state={{ category }}
                      >
                        {category.categoryName}
                      </Link>
                      {idx < categories.length - 1 && (
                        <span className="mx-3 !text-white/40 select-none">•</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Bottom Footer */}
          <div className="mt-16 pt-8 border-t border-slate-800/80 flex flex-col md:flex-row items-center justify-between gap-6 text-[13px] !text-white">
            {/* Copyright and Trademarks info */}
            <div className="text-center md:text-left space-y-2 max-w-2xl">
              <p className="text-[14px] !text-white">
                © 2025 <span className="!text-white font-medium">{t("yslearn")}</span>. {t("All Rights Reserved")}.
              </p>
              <p className="text-[12px] leading-relaxed !text-white/80">
                {t("The certification names are the trademarks of their respective owners.")}
              </p>
              <p className="text-[12px] !text-white/80">
                {t("Phone No")}: <a href="tel:+919597684055" className="!text-white hover:!text-blue-500 transition-colors">+91 9597 684 055</a>
              </p>
            </div>

            {/* Legal links and Country Selector */}
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <div className="flex flex-wrap items-center justify-center gap-4 !text-white">
                <Link
                  to="/terms-and-conditions"
                  className="!text-white hover:!text-blue-500 transition-colors duration-200"
                >
                  {t("Terms and Conditions")}
                </Link>
                <span className="!text-white/40 select-none">•</span>
                <Link to="/privacy" className="!text-white hover:!text-blue-500 transition-colors duration-200">
                  {t("Privacy Policy")}
                </Link>
                <span className="!text-white/40 select-none">•</span>
                <Link
                  to="/refund-policy"
                  className="!text-white hover:!text-blue-500 transition-colors duration-200"
                >
                  {t("Refund Policy")}
                </Link>
              </div>

              {/* Country Selector */}
              <div className="flex items-center gap-2.5 bg-slate-900 border border-slate-800 rounded-lg px-3 py-1.5 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-200">
                <label htmlFor="country-select" className="sr-only">
                  {t("Country")}
                </label>
                <select
                  id="country-select"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  className="bg-transparent border-none !text-white text-xs focus:outline-none cursor-pointer pr-1"
                >
                  <option value="" className="bg-slate-950">{t("Select Country")}</option>
                  <option value="IN" className="bg-slate-950">{t("India")}</option>
                  <option value="US" className="bg-slate-950">{t("United States")}</option>
                  <option value="GB" className="bg-slate-950">{t("United Kingdom")}</option>
                  <option value="CA" className="bg-slate-950">{t("Canada")}</option>
                  <option value="AU" className="bg-slate-950">{t("Australia")}</option>
                </select>
                {selectedCountry && (
                  <CountryFlag
                    countryCode={selectedCountry}
                    svg
                    style={{
                      width: "1.2em",
                      height: "0.8em",
                      borderRadius: "1px",
                    }}
                    title={selectedCountry}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </footer>
  );
}

export default Footer;
